import { PrinterPosCogIcon } from './PrinterPosCogIcon';

/**
 * author: Colton Wiscombe
 * id 6566732F-0DDF-4F23-B478-AC3A93B822BE
 * name printer-pos-cog
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-cog.svg
 * tags
 * - Printer 
 */
export const PrinterPointOfSaleCogIcon = PrinterPosCogIcon;
export default PrinterPointOfSaleCogIcon